/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {FinancialAvailability} from "./financialAvailability.zod";
import {Money} from "./money.zod";

export const OfferFinancials = zod
  .unknown()
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(
    zod.object({
      totalValueAvailability: zod.enum(["AVAILABLE", "UNAVAILABLE", "NOT_PRICED"]),
      supplierCostAvailability: zod.enum(["AVAILABLE", "RESTRICTED", "UNAVAILABLE"]),
      commissionAvailability: FinancialAvailability,
      benefitAvailability: FinancialAvailability,
      totalValue: Money.optional(),
      supplierCost: Money.optional(),
      commissionAmount: Money.optional(),
      benefitValue: Money.optional(),
      benefitPercentage: zod
        .number()
        .nullish()
        .describe(
          "100 times benefitValue divided by totalValue using DECIMAL128 division (34 significant digits, HALF_EVEN). Monetary Currency rounding is unchanged; null only when available calculation has zero selling total.",
        ),
    }),
  )
  .describe(
    "Ordinary aggregates include only non-optional Chapters. Known supplier cost does not require coefficient decisions. Restrict revealing aggregates only for their actual protected contributors; protected optional Chapters do not restrict these ordinary facts. Genuine zero, NOT_PRICED and unavailable differ. Benefit percentage is null only at available zero selling total.",
  );

export type OfferFinancials = zod.input<typeof OfferFinancials>;
export type OfferFinancialsOutput = zod.output<typeof OfferFinancials>;
